// extracted by mini-css-extract-plugin
module.exports = {"spinner":"LoadingSpinner_spinner__J_fy8","spinnerImage":"LoadingSpinner_spinnerImage__2C0xs"};